import React, { useMemo, useState } from 'react'
import { AlertType, Caixa, bgLineGridColorDark, bgLineGridColorLight, contaAPagar, corBgGrid } from '../../Utils/Types'
import { createTheme, ThemeProvider, useTheme } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import moment from 'moment'
import { Funcoes } from '../../Utils/Funcoes'

type Props = {
    extratoList: Caixa[],
}

type VisibilityState = Record<string, boolean>

export type TipoStatus = | "A" | "L"

interface RowData {
    data: string,
    desc_conta: string,
    valor: number,
    tipo: string,
    historico: string,
    acumulado: number,
}

export const GridExtratoContas = React.memo(({ extratoList }: Props) => {

    /*
    const xJson = localStorage.getItem("@commerce/column_grid_ctapagar")

    //let json: any = {acao: true, desc_grupo_despesa: true, dt_cadastro: true, dt_liquidacao: true, dt_vencimento: true,
                estornar: false, liquidar: true, nome_fornecedor: true, num_doc: true,  observacao: true, serie: true, valor: true}

    if (xJson){
        json  = JSON.parse(localStorage.getItem("@commerce/column_grid_ctapagar") || '')
    }

    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10, // personaliza o tamanho padrão da página  
    })

    const PLACES = ['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end']
    const [idExcluir, setIdExcluir] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [state, setState] = useState(false)
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    //const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(json)
    */

    let user = useSelector(state => selectUser(state));

    const theme = createTheme({
        palette: {
            mode: user.modeDark,
            background: {
                default: user.modeDark === 'light' ? '#fff'  : '#475569',
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'

    //let colunasArray: MRT_ColumnDef<Caixa>[] = []

    const columns = useMemo<MRT_ColumnDef<Caixa>[]>(() => [
        
        {
            accessorKey: 'data', header: 'Data', visibleInShowHideMenu: true, size: 50, minSize: 10, maxSize: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData;

                return (<span>{rowData.data ? moment(rowData.data).format('DD/MM/YYYY') : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'Histórico', visibleInShowHideMenu: true, header: 'Histórico', size: 400, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData;

                return (<span>{rowData.historico ? rowData.historico : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'valor', visibleInShowHideMenu: true, header: 'Valor', size: 150, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {
                const rowData = cell.row.original as RowData;

                return (<span>{rowData.valor ? Funcoes.numberFormat(rowData.valor) : <span className=''>0</span>}</span>)

            }
        },

        {
            accessorKey: 'tipo', visibleInShowHideMenu: true, header: 'Tipo do lançamento', grow: false, size: 10, minSize: 10, maxSize: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left', },
            
            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData;

                return (<span>{rowData.tipo ? rowData.tipo === "D" ? 'Débito' : 'Crédito' : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'acumulado', visibleInShowHideMenu: true, header: 'Acumulado', size: 150, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },
            
            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData;

                return (<span>{rowData.acumulado ? Funcoes.numberFormat(rowData.acumulado) : <span className=''>0</span>}</span>)

            }
        },

    ], [])

    const table = useMaterialReactTable({
        paginationDisplayMode: 'pages',
        columns: columns,
        data: extratoList,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,
        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },

            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        localization: MRT_Localization_PT_BR,
        enableEditing: false,
        enableTopToolbar: false,
        enableColumnActions: false,
        enableColumnFilters: false,
        enableHiding: false,
        enableFilters: false,
        enableMultiSort: false,
        enableSorting: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        enableColumnPinning: false,
    })

    return (
        <>

            {/*
            <FeedbackMessage visible={feedBackVisible} message={messageFeedBack} 
            
            type={alertType} onCloseMessage={() => { setFeedBackVisible(false) }} />
            */}


            <ThemeProvider theme={theme}>
                <MaterialReactTable table={table} />
            </ThemeProvider>

        </>
    )

})